import script from "./HomeDestaques.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeDestaques.vue?vue&type=script&setup=true&lang=js"

import "./HomeDestaques.vue?vue&type=style&index=0&id=48bce7c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48bce7c0"]])

export default __exports__